export const Info = [
    {
        id: 1,
        title : "Chat App",
        description : "This is a chat app made using reactjs and firebase for backend.",
        image : "assets/images/chat-app.png",
        url : "https://aleem-chat-app.vercel.app/"
    },
    {
        id: 2,
        title : "Movie Search Engine",
        description : "Using OMDb API for Movie related info, created this responsive webpage in reactjs.",
        image : "assets/images/project1.png",
        url : "https://mirzaaleem.github.io/SearchMovie/"
    },
    
    {
        id: 3,
        title : "Social Media Website",
        description : "This is a social media website made using MERN stack.",
        image : "assets/images/Ayila.png",
        url : "https://ayila.netlify.app/"
    },

    {
        id: 4,
        title : "Expense Tracker",
        description : "This Expense Tracker was made to practice Reactjs and Material UI.",
        image : "assets/images/expense.png",
        url : "https://expensetracki.netlify.app/"
    }
]